const colours = {
    very_dark_grey: 0x141414,
    white: 0xffffff,
    dark_grey: 0x202020,
    light_pink: 0xFFC0CB,
    bright_pink: 0xfb8da0,
    pink: 0xff4162,
  };
  
export default colours;